(() => {
  const verificationError = 'We could not verify product eligibility. Please refresh and try again.';

  async function getEligibility(path) {
    const url = new URL(path, window.location.origin);
    url.searchParams.set('section_id', 'purchase-eligibility');
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) {
      throw new Error(verificationError);
    }
    const document = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = document.querySelector('[data-purchase-eligibility]');
    if (!data) {
      throw new Error(verificationError);
    }
    const eligibility = JSON.parse(data.textContent);
    if (!Array.isArray(eligibility.variants) || !Array.isArray(eligibility.items)) {
      throw new Error(verificationError);
    }
    return eligibility;
  }

  async function requireVariant(id, productUrl) {
    const eligibility = await getEligibility(productUrl);
    const variant = eligibility.variants.find((variant) => variant.id === String(id));
    if (!variant || variant.allowed !== true) {
      throw new Error('This product is not available for your account. Please refresh your cart.');
    }
  }

  // Reload after removal so totals, minimum spend, and positional cart inputs stay in sync.
  async function removeIneligibleItems() {
    const eligibility = await getEligibility(window.Shopify.routes.root + 'cart');
    const updates = {};
    for (const item of eligibility.items) {
      if (item.variant.allowed !== true) {
        updates[item.key] = 0;
      }
    }
    if (Object.keys(updates).length === 0) {
      return true;
    }
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
    if (!response.ok) {
      throw new Error(verificationError);
    }
    try {
      sessionStorage.setItem(
        'purchaseEligibilityNotice',
        'Items unavailable for your account were removed from your cart.',
      );
    } catch {
      // Storage can be unavailable; cart cleanup must still take effect.
    }
    window.location.reload();
    return false;
  }

  let cartCleanup;
  function cleanCart() {
    if (!cartCleanup) {
      cartCleanup = removeIneligibleItems()
        .then((ready) => {
          // Keep blocking while a reload is pending after removal.
          if (ready) {
            cartCleanup = null;
          }
          return ready;
        })
        .catch((error) => {
          cartCleanup = null;
          throw error;
        });
    }
    return cartCleanup;
  }

  window.purchaseEligibility = { requireVariant, cleanCart };

  document.addEventListener('DOMContentLoaded', async () => {
    const message = document.getElementById('purchaseEligibilityMessage');
    if (!message) {
      return;
    }
    try {
      const notice = sessionStorage.getItem('purchaseEligibilityNotice');
      sessionStorage.removeItem('purchaseEligibilityNotice');
      if (notice) {
        message.textContent = notice;
        message.hidden = false;
      }
    } catch {
      // Cart validation does not depend on browser storage.
    }
    try {
      await cleanCart();
    } catch (error) {
      message.textContent = error.message;
      message.hidden = false;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-eligible-product-url]');
    if (!form) {
      return;
    }
    event.preventDefault();
    if (form.dataset.checkingEligibility) {
      return;
    }
    form.dataset.checkingEligibility = 'true';
    try {
      await requireVariant(form.elements.id.value, form.dataset.eligibleProductUrl);
      HTMLFormElement.prototype.submit.call(form);
    } catch (error) {
      window.alert(error.message);
      delete form.dataset.checkingEligibility;
    }
  });
})();
